import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, ListGroup, Button, Breadcrumb, Card } from 'react-bootstrap';
import './App.css'; // Import your CSS file for styling
import { useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { Download } from 'lucide-react';
import axios from 'axios';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function Results() {
  let storedData = sessionStorage.getItem("analysed_data");
  if(storedData) {
    storedData = JSON.parse(storedData);
  }
  const pdfUrl = (storedData?.url+storedData?.results?.file_name);
  const [pageNum, setPageNum] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1); // To track the current page number
  const pdfRef = useRef(null);
  const pageNumRef = useRef(null);
  const navigate = useNavigate();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPageNumber(numPages); // Store the total number of pages in the document
  };

  const getSetPageScroll = (index_page) => {
    const pageHeight = (pdfRef.current.children[0].clientHeight+10)*(index_page-1);
    pdfRef.current.scrollTo({
      top: pageHeight,
    });
    getSetPage(index_page);
  }

  const getSetPage = (index_page) => {
    const x = storedData?.results?.failed_results.filter((x, index)=>index===(index_page-1))[0].page;
    setPage(x, index_page-1, true);
  }

  const setPageScroll = (newPageNum, index_page) => {
    const pageHeight = (pdfRef.current.children[0].clientHeight+10)*(index_page);
    pdfRef.current.scrollTo({
      top: pageHeight,
    });
    setPage(newPageNum, index_page, false);
  }

  const setPage = (newPageNum, index_page, intoView) => {
    setPageNum(newPageNum);
    setCurrentPage(index_page+1);
    if (intoView) {
      pageNumRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  useEffect(() => {
    if (!storedData?.results) {
      navigate("/formatcheck");
    }

    setPageData(storedData?.results?.failed_results.filter(x=>x.page===pageNum)[0]['validation_results']);
  }, [pageNum]);

  const handleScroll = (event) => {
    let containerHeight = 0;
    if(event.deltaY > 0) {
      containerHeight = pdfRef.current.scrollTop+100;
    } else {
      containerHeight = pdfRef.current.scrollTop+(pdfRef.current.clientHeight/2);
    }
    const pageHeight = pdfRef.current.children[0].clientHeight;
    const newPage = Math.ceil(containerHeight/pageHeight);
    if (currentPage !== newPage) {
      getSetPage(newPage);
    }
  };

  const downloadPdf = () => {
    axios.get(pdfUrl,
      {
          responseType: 'arraybuffer',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
          }
      })
      .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', storedData?.results?.file_name?.split('/')[1]);
          document.body.appendChild(link);
          link.click();
      })
      .catch((error) => console.log(error));
  }

  return (
    <Container fluid className='mt-10'>
      <Row>
        <Col md={3}>
          <Card>
            <Card.Header>All Page Issues</Card.Header>
            <ListGroup variant="flush" className='page-issues'>
              {storedData?.results?.failed_results?.map((fr, index) => {return <ListGroup.Item className={fr.page === pageNum ? 'active-page' : ''} ref={fr.page === pageNum ? pageNumRef : null} key={fr.page} onClick={()=>setPageScroll(fr.page, index)}>Page Number: {fr.page}</ListGroup.Item>})}
            </ListGroup>
          </Card>
          <Card className="mt-3">
            <Card.Header>Current Page Issues</Card.Header>
            <ListGroup variant="flush" className='view-issues'>

              {pageData?.length === 0 &&<ListGroup.Item >No issues found for the current page.</ListGroup.Item>}
              {pageData?.map(pd => {return <ListGroup.Item>{pd.message}</ListGroup.Item>})}
            </ListGroup>
          </Card>
        </Col>
        <Col md={9}>
          <Card>
            <Card.Header>
              <Breadcrumb>
                <Breadcrumb.Item active>Page Preview</Breadcrumb.Item>
                <Breadcrumb.Item active>{`Page ${pageNum}`}</Breadcrumb.Item>

                <Breadcrumb.Item active className='note-bread'>
                  <b>Note:</b> The Title and Approval page will be checked by the Graduate School office.<br/>
                  Some image/table has a white background exceeding the required margins, marking some pages as an error. The Graduate School will approve such pages.
                </Breadcrumb.Item>
              </Breadcrumb>
            </Card.Header>
            <Card.Body className='pdf-viewer'>
              <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                <div ref={pdfRef} style={{ overflowY: 'scroll', height: '75vh', width: '100%' }} onWheel={handleScroll}>
                  {Array.from({ length: pageNumber }, (_, index) => (
                    <Page
                      key={index}
                      pageNumber={index + 1}
                      width={'800'}
                    />
                  ))}
                </div>
              </Document>
            </Card.Body>
            <Card.Footer>
              <Button variant="outline-secondary" onClick={() => getSetPageScroll(currentPage - 1)} disabled={currentPage === 1}>
                Previous
              </Button>{' '}
              <span>Page {currentPage} of {storedData?.results?.failed_results?.length}</span>{' '}
              <Button variant="outline-secondary" onClick={() => getSetPageScroll(currentPage + 1)} disabled={currentPage === storedData?.results?.failed_results?.length}>
                Next
              </Button>

              <Button variant='primary' className='flr' onClick={downloadPdf}><Download /> Download</Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      <Button variant="primary" className="feedback-button" onClick={() => window.open('https://forms.gle/i9KW7v4Qewb34BUe7', "_blank")}>feedback</Button>
    </Container>
  );
}

export default Results;